import { DatePicker, Panel, PanelType } from "@fluentui/react";
import { useCallback } from "react";
import { PanelHeader } from "../../../../components/Panel/PanelHeader";
import { PanelFooter } from "../../../../components/Panel/PanelFooter";
import { onFormatDate } from "../../../../utils/helpers/dateHelpers";
import { ComboBoxIDS } from "../../../../components/generic/ComboBoxIDS";
import { DescargarArchivo } from "../../../../components/archivo/DescargarArchivo";
import { useComboGuardias } from "../../../../hooks/combosHooks/useComboGuardias";
import { useComboAreas } from "../../../../hooks/combosHooks/useComboAreas";
import { useReporteHistoricoDispositivo } from "../../../../hooks/Reportes/useReporteHistoricoDispositivo";
interface IPanelFilterDispositivoHistorico {
  isOpen: boolean;
  onDismiss: () => void;
  onChangeComboBox: (e, o, text) => void;
  onSelectDate: (date: Date | null | undefined, text: string) => void;
  filterFechas: any;
  limpiarFiltro: () => void;
  filterReporte: any;
  buscar: () => void;
}

export const PanelFilterDispositivoHistorico = (
  props: IPanelFilterDispositivoHistorico
) => {
  /* Custom Hooks */
  const { comboBoxRefGuardias, dataComboGuardia, onClickOpenGuardias } =
    useComboGuardias();
  const { _onKeyUpSearchArea, comboBoxAreaRef, dataComboArea, onClickOpen } =
    useComboAreas();
  const { handlerPostReporteDispositivoHistorico, isSend } =
    useReporteHistoricoDispositivo(props.onDismiss);

  const onRenderFooterPanel = useCallback(
    () => (
      <>
        <PanelFooter
          texto="Buscar"
          texto2={"Limpiar"}
          onClick={props.buscar}
          disableButton={false}
          onDismiss={props.limpiarFiltro}
        />
      </>
    ),
    [props.onDismiss, props.limpiarFiltro]
  );

  const onRenderHeaderPanel = useCallback(
    () => (
      <PanelHeader
        textHeader="Filtro de Dispositivo Histórico"
        subTextHeader={`Búsqueda Avanzada`}
      />
    ),
    []
  );
  return (
    <>
      <Panel
        type={PanelType.smallFixedFar}
        onRenderHeader={onRenderHeaderPanel}
        onRenderFooter={onRenderFooterPanel}
        isFooterAtBottom
        isBlocking={false}
        isOpen={props.isOpen}
        onDismiss={props.onDismiss}
      >
        <div className="ms-Grid" dir="ltr">
          <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
              <br />
              <br />
              <DatePicker
                label="Fecha Entrega:"
                placeholder="dd/mm/yyyy"
                value={props.filterFechas.filterFechaInicio}
                ariaLabel="Seleccione una fecha"
                onSelectDate={(data?: any) => {
                  props.onSelectDate(data, "inicio");
                }}
                formatDate={onFormatDate}
                underlined
              />
            </div>
            <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
              <br />
              <br />
              <DatePicker
                label="Fecha Entrega:"
                placeholder="dd/mm/yyyy"
                value={props.filterFechas.filterFechaFin}
                ariaLabel="Seleccione una fecha"
                onSelectDate={(data?: any) => {
                  props.onSelectDate(data, "fin");
                }}
                formatDate={onFormatDate}
                minDate={props.filterFechas.filterFechaInicio}
                underlined
              />
            </div>
            <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
              <br />
              <br />
              <ComboBoxIDS
                title="Guardia:"
                componentRef={comboBoxRefGuardias}
                selectedKey={props.filterReporte?.guardia}
                onClick={onClickOpenGuardias}
                useComboBoxAsMenuWidth
                onChange={(e, o) => props.onChangeComboBox(e, o, "guardia")}
                KeyUp={undefined}
                options={dataComboGuardia}
              />
            </div>
            <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
              <br />
              <br />
              <ComboBoxIDS
                title="Area:"
                componentRef={comboBoxAreaRef}
                selectedKey={props.filterReporte?.areaId}
                onClick={onClickOpen}
                useComboBoxAsMenuWidth
                onChange={(e, o) => props.onChangeComboBox(e, o, "area")}
                KeyUp={_onKeyUpSearchArea}
                options={dataComboArea}
              />
            </div>
          </div>
        </div>
        <DescargarArchivo
          onClick={() => {
            handlerPostReporteDispositivoHistorico(props.filterReporte);
          }}
          isSend={isSend}
        />
      </Panel >
    </>
  );
};
